import { useNavigate } from "react-router-dom";
import { Modal } from "@mui/material";
import PropTypes from "prop-types";
import Button from "./Button";

const LoginModal = ({ isOpen, message, body, onClose }) => {
  const navigate = useNavigate();

  const handleSubmit = () => {
    navigate(`/activate/choose-membership`);
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className="flex backdrop-blur-md bg-opacity-20 overflow-y-scroll"
    >
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <div className="grid grid-cols-1 divide-y">
          <div className="w-full flex justify-center">
            <div className="w-full text-center text-lg font-bold ">
              {message}
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:mt-2">
          <div className="text-center font-[Lato]">
            <div>{body}</div>
          </div>
          <Button
            className="w-full h-10 rounded-xl font-semibold mt-2 text-white transition ease-in-out delay-75 hover:scale-105 "
            onClick={handleSubmit}
          >
            Get Started
          </Button>
        </div>
      </div>
    </Modal>
  );
};

LoginModal.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  body: PropTypes.any,
};

export default LoginModal;
